import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const SleepIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M19.2 19.88A11.78 11.78 0 0 1 7.56 2.31a.59.59 0 0 0-.76-.85 13.62 13.62 0 0 0-1.47.85 11.85 11.85 0 0 0-4.2 14.61 11.48 11.48 0 0 0 1 1.67 12.83 12.83 0 0 0 1.16 1.53 11.85 11.85 0 0 0 15.09 1.82 12.64 12.64 0 0 0 1.35-1 .59.59 0 0 0-.53-1.06Z" />
      <path d="m9.42 9.89 2.09-.09 1.05 1.81a.43.43 0 0 0 .78-.1l.56-2 2-.44a.43.43 0 0 0 .14-.78l-1.69-1.18.21-2.11a.44.44 0 0 0-.7-.38L12.23 6l-1.92-.84a.42.42 0 0 0-.57.54l.73 2-1.39 1.47a.43.43 0 0 0 .34.72ZM22 10.7l-1.29.12L20 9.73a.27.27 0 0 0-.49.08l-.29 1.27-1.22.33a.27.27 0 0 0-.07.49l1.11.67-.04 1.29a.27.27 0 0 0 .45.22l1-.85 1.21.46a.26.26 0 0 0 .34-.35l-.51-1.19.82-1a.27.27 0 0 0-.31-.45ZM23.72 3.5 22 2.93l-.31-1.81A.38.38 0 0 0 21 1l-1.1 1.44-1.82-.27a.38.38 0 0 0-.36.6l1.08 1.49-.8 1.65a.38.38 0 0 0 .46.52l1.75-.56 1.29 1.29a.39.39 0 0 0 .65-.27V5.05l1.63-.85a.38.38 0 0 0-.06-.7Z" />
    </IconBase>
  );
};

export default SleepIcon;
